export default function seoWidget({
  widgetNameVariable,
  widgetOptsVariable,
  useImageBackground = false,
  useDividers = false,
}) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOptsVariable;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = `${widgetName}-container`;

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    hasImages: useImageBackground,
    link: [''],
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items[0]);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomSeo(widgetData) {
    const { Title, Description, ImageWithPath } = widgetData;
    const $seo = $widget.find('.card-widget-item');

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      ${useDividers ? '<hr class="seo-divider">' : ''}
      <div class="seo-description">${Description}</div>
      ${useDividers ? '<hr class="seo-divider mobile-divider">' : ''}
    `);

    if (useImageBackground && ImageWithPath) {
      $(`.${wrapContainerClass}`).css({
        background: `url('${ImageWithPath}')`,
      });
    }
  }
}
